export const DASHBOARD_HANDLE_MAIN_MENU_ITEM_CLICK = 'DASHBOARD_HANDLE_MAIN_MENU_ITEM_CLICK';
export const DASHBOARD_HANDLE_TOP_MENU_ITEM_CLICK = 'DASHBOARD_HANDLE_TOP_MENU_ITEM_CLICK'
export const DASHBOARD_LOGOUT_INIT = 'DASHBOARD_LOGOUT_INIT';
export const DASHBOARD_LOGOUT_SUCCESS = 'DASHBOARD_LOGOUT_SUCCESS';
export const DASHBOARD_LOGOUT_FAILURE = 'DASHBOARD_LOGOUT_FAILURE';
export const DASHBOARD_GET_USER_PROFILE_INIT = 'DASHBOARD_GET_USER_PROFILE_INIT';
export const DASHBOARD_GET_USER_PROFILE_SUCCESS = 'DASHBOARD_GET_USER_PROFILE_SUCCESS';
export const DASHBOARD_GET_USER_PROFILE_FAILURE = 'DASHBOARD_GET_USER_PROFILE_FAILURE';
export const DASHBOARD_SET_ACTIVE_MAIN_MENU = 'DASHBOARD_SET_ACTIVE_MAIN_MENU';
export const DASHBOARD_SET_ON_SCROLL_BOTTOM_ACTION = 'DASHBOARD_SET_ON_SCROLL_BOTTOM_ACTION';
export const DASHBOARD_UNSET_ON_SCROLL_BOTTOM_ACTION = 'DASHBOARD_UNSET_ON_SCROLL_BOTTOM_ACTION';
export const DASHBOARD_SAVE_ACTUAL_USER_INIT = 'DASHBOARD_SAVE_ACTUAL_USER_INIT';
export const DASHBOARD_SAVE_ACTUAL_USER_SUCCESS = 'DASHBOARD_SAVE_ACTUAL_USER_SUCCESS';
export const DASHBOARD_SAVE_ACTUAL_USER_FAILURE = 'DASHBOARD_SAVE_ACTUAL_USER_FAILURE';
export const DASHBOARD_SET_SAVE_ACTUAL_USER_DATA_BY_KEY = 'DASHBOARD_SET_SAVE_ACTUAL_USER_DATA_BY_KEY';
export const DASHBOARD_SAVE_ACTUAL_USER_RESET = 'DASHBOARD_SAVE_ACTUAL_USER_RESET';

export const DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_INIT = 'DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_INIT';
export const DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_SUCCESS = 'DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_SUCCESS';
export const DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_FAILURE = 'DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_FAILURE';
export const DASHBOARD_GET_NOTIFICATIONS_INIT = 'DASHBOARD_GET_NOTIFICATIONS_INIT';
export const DASHBOARD_GET_NOTIFICATIONS_SUCCESS = 'DASHBOARD_GET_NOTIFICATIONS_SUCCESS';
export const DASHBOARD_GET_NOTIFICATIONS_FAILURE = 'DASHBOARD_GET_NOTIFICATIONS_FAILURE';
export const DASHBOARD_GET_NOTIFICATION_INIT = 'DASHBOARD_GET_NOTIFICATION_INIT';
export const DASHBOARD_GET_NOTIFICATION_SUCCESS = 'DASHBOARD_GET_NOTIFICATION_SUCCESS';
export const DASHBOARD_GET_NOTIFICATION_FAILURE = 'DASHBOARD_GET_NOTIFICATION_FAILURE';
export const DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_INIT = 'DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_INIT';
export const DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_SUCCESS = 'DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_SUCCESS';
export const DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_FAILURE = 'DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_FAILURE';
export const DASHBOARD_DELETE_NOTIFICATION_DATA_INIT = 'DASHBOARD_DELETE_NOTIFICATION_DATA_INIT';
export const DASHBOARD_DELETE_NOTIFICATION_DATA_SUCCESS = 'DASHBOARD_DELETE_NOTIFICATION_DATA_SUCCESS';
export const DASHBOARD_DELETE_NOTIFICATION_DATA_FAILURE = 'DASHBOARD_DELETE_NOTIFICATION_DATA_FAILURE';

export const DASHBOARD_GET_CUSTOMER_INIT = 'DASHBOARD_GET_CUSTOMER_INIT'
export const DASHBOARD_GET_CUSTOMER_SUCCESS = 'DASHBOARD_GET_CUSTOMER_SUCCESS'
export const DASHBOARD_GET_CUSTOMER_FAILURE = 'DASHBOARD_GET_CUSTOMER_FAILURE'
export const DASHBOARD_UPDATE_CUSTOMER_INIT = 'DASHBOARD_UPDATE_CUSTOMER_INIT'
export const DASHBOARD_UPDATE_CUSTOMER_SUCCESS = 'DASHBOARD_UPDATE_CUSTOMER_SUCCESS'
export const DASHBOARD_UPDATE_CUSTOMER_FAILURE = 'DASHBOARD_UPDATE_CUSTOMER_FAILURE'
export const DASHBOARD_SET_UPDATE_CUSTOMER_DATA_BY_KEY = 'DASHBOARD_SET_UPDATE_CUSTOMER_DATA_BY_KEY'
export const DASHBOARD_UPDATE_CUSTOMER_RESET = 'DASHBOARD_UPDATE_CUSTOMER_RESET'

export const DASHBOARD_STOP_PROCESS_INIT = 'DASHBOARD_STOP_PROCESS_INIT'
export const DASHBOARD_STOP_PROCESS_SUCCESS = 'DASHBOARD_STOP_PROCESS_SUCCESS'
export const DASHBOARD_STOP_PROCESS_FAILURE = 'DASHBOARD_STOP_PROCESS_FAILURE'

export const DASHBOARD_GET_PERIODS_LIST_INIT = 'DASHBOARD_GET_PERIODS_LIST_INIT';
export const DASHBOARD_GET_PERIODS_LIST_SUCCESS = 'DASHBOARD_GET_PERIODS_LIST_SUCCESS';
export const DASHBOARD_GET_PERIODS_LIST_FAILURE = 'DASHBOARD_GET_PERIODS_LIST_FAILURE';

export const DASHBOARD_SET_FIXED_PERIOD_ID = 'DASHBOARD_SET_FIXED_PERIOD_ID';

export const DASHBOARD_RESET = 'DASHBOARD_RESET';

export const DASHBOARD_SET_HANDLE_NOTIFICATION_DETAIL_POPUP_REFERENCE = 'DASHBOARD_SET_HANDLE_NOTIFICATION_DETAIL_POPUP_REFERENCE';

export const DASHBOARD_SET_HANDLE_CHECK_ROUTE_TOUR_AVAILABILITY_REFERENCE = 'DASHBOARD_SET_HANDLE_CHECK_ROUTE_TOUR_AVAILABILITY_REFERENCE';

export const  DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_INIT = 'DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_INIT';
export const  DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_SUCCESS = 'DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_SUCCESS';
export const  DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_FAILURE = 'DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_FAILURE';

export const DASHBOARD_GET_TOURS_STATE_INIT = 'DASHBOARD_GET_TOURS_STATE_INIT';
export const DASHBOARD_GET_TOURS_STATE_SUCCESS = 'DASHBOARD_GET_TOURS_STATE_SUCCESS';
export const DASHBOARD_GET_TOURS_STATE_FAILURE = 'DASHBOARD_GET_TOURS_STATE_FAILURE';

export const DASHBOARD_SET_TOURS_STATE_INIT = 'DASHBOARD_SET_TOURS_STATE_INIT';
export const DASHBOARD_SET_TOURS_STATE_SUCCESS = 'DASHBOARD_SET_TOURS_STATE_SUCCESS';
export const DASHBOARD_SET_TOURS_STATE_FAILURE = 'DASHBOARD_SET_TOURS_STATE_FAILURE';

export const DASHBOARD_SET_ACTIVE_TOUR_FUNCTION_REFERENCE = 'DASHBOARD_SET_ACTIVE_TOUR_FUNCTION_REFERENCE';

export const  DASHBOARD_SAVE_USER_IMAGE_INIT = 'DASHBOARD_SAVE_USER_IMAGE_INIT';
export const  DASHBOARD_SAVE_USER_IMAGE_SUCCESS = 'DASHBOARD_SAVE_USER_IMAGE_SUCCESS';
export const  DASHBOARD_SAVE_USER_IMAGE_FAILURE = 'DASHBOARD_SAVE_USER_IMAGE_FAILURE';



// WEBPACK FOOTER //
// ./source/client/actions/dashboard/types.js